import { NavigateFunction } from 'react-router-dom';

class TokenExpirationHandler {
  private navigate: NavigateFunction | null = null;
  private logoutCallback: (() => void) | null = null;

  // Initialize with navigation function and logout callback
  init(navigate: NavigateFunction, logoutCallback: () => void) {
    this.navigate = navigate;
    this.logoutCallback = logoutCallback;
  }

  // Handle token expiration
  handleTokenExpiration() {
    console.log('Token expired, redirecting to login...');
    
    // Clear auth data
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    
    // Call logout callback if available
    if (this.logoutCallback) {
      this.logoutCallback();
    }
    
    // Navigate to login page
    if (this.navigate) {
      this.navigate('/login', { 
        state: { 
          message: 'Your session has expired. Please log in again.',
          from: window.location.pathname 
        },
        replace: true 
      });
    } else {
      // Fallback to window.location if navigate is not available
      console.log('Navigate function not available, using window.location');
      window.location.href = '/login';
    }
  }

  // Check if token is expired
  isTokenExpired(token: string | null): boolean {
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      console.error('Error checking token expiration:', error);
      return true;
    }
  }

  // Get token expiration time
  getTokenExpirationTime(token: string | null): Date | null {
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return new Date(payload.exp * 1000);
    } catch (error) {
      console.error('Error getting token expiration time:', error);
      return null;
    }
  }

  // Get time until token expires (in milliseconds)
  getTimeUntilExpiration(token: string | null): number {
    if (!token) return 0;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const timeUntilExpiration = (payload.exp - currentTime) * 1000;
      return Math.max(0, timeUntilExpiration);
    } catch (error) {
      console.error('Error calculating time until expiration:', error);
      return 0;
    }
  }
}

export default new TokenExpirationHandler(); 